export const HttpStatusCodeEnum = {
    UNAUTHORIZED: 401,
    BADDATA: 400,
};

export const ContentTypeEnum = {
    CSV: 'text/csv',
    MULTIPART: 'multipart/form-data',
};

export const ReconStatusTypeEnum = {
    SUCCESS: 'SUCCESS',
    INPROGRESS: 'IN PROGRESS',
    NOTSTARTED: 'UNSTARTED',
    FAILURE: 'FAILURE',
    COMPLETE: 'COMPLETE',
};

export const ProjectStatusTypeEnum = {
    OPEN: 'open',
    ARCHIVED: 'archived',
    RESOLVED: 'resolved',
};

export const RulesLandingPageNameEnum = {
    FRY7Q: 'FRY7Q Diagnostic Results',
    FRY9C: 'FRY9C Diagnostic Results',
    METRO2: 'Metro2 Diagnostic Results',
    FFIEC009: 'FFIEC009 Diagnostic Results',
    FR2052A: 'FR 2052A Diagnostic Results',
    FFIEC031: 'FFIEC031 Diagnostic Results',
    FFIEC041: 'FFIEC041 Diagnostic Results',
};

export const ModuleEnum = {
    RULEENGINE: 'Rule Engine',
    DATARECONCILIATION: 'Data Reconciliation',
    CROSSREPORTVALIDATION: 'Cross Report Validation',
    TRENDANALYTICS: 'Trend Analytics',
    USER: 'User',
    TENANT: 'Tenant',
    INTAKE: 'Intake',
};

export const ModuleIdEnum = {
    RULEENGINE: 2,
    DATARECONCILIATION: 1,
    CROSSREPORTVALIDATION: 3,
    TRENDANALYTICS: 4,
    DEMO: 5,
    BENCHMARK: 6,
};

export const RegulationEnum = {
    FRY7Q: 'FR Y-7Q',
    FRY9C: 'FR Y-9C',
    METRO2: 'Metro2',
    FFIEC009: 'FFIEC009',
    FR2052A: 'FR 2052a',
    FFIEC031: 'FFIEC 031',
    FFIEC041: 'FFIEC 041',
};

export const PageSizeOptionEnum = {
    FIVE: 5,
    TEN: 10,
    FIFTEEN: 15,
    TWENTY: 20,
    TWENTYFIVE: 25,
};

export const ToastTypeEnum = {
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    DARK: 'dark',
    ERROR: 'error',
};
